export const RESPONSIBLE_GAMING_SINGLE_BET_LIMIT = 'responsible-gaming-single-bet-limit';
